import ModusServiceCollection from "../ModusServiceCollection";
import ResultNutrientModel from "../../models/modus/ResultNutrientModel";

/**
 * ResultNurtient collection
 */
export default class ResultNutrientCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ResultNutrientModel;
  }

}
